export default __webpack_public_path__ + "static/media/student_login_pear_practice.842a0fe8.png";